import { Button, Modal, InputItem } from "antd-mobile";
import { useCallback, useState } from "react";
import instance from "../../util/axios";
import styled from "styled-components";
import { getQueryString } from "../../util/getQueryString";

const type: string = getQueryString("type") || "";
export default function WebsiteRegister() {
  const [visible, setVisible] = useState<boolean>(false);
  // 姓名
  const [name, setName] = useState<string>();
  // 手机号
  const [phone, setPhone] = useState<string>();
  // 公司
  const [company, setCompany] = useState<string>();
  // 职位
  const [position, setPosition] = useState<string>();
  // 微信
  const [wx, setWx] = useState<string>();

  const onSubmit = useCallback(() => {
    const token = "新起点-推送账号-098765";
    const reltoken = encodeURIComponent(token);
    const URL = `https://i.tysoft.com/crm/clue/pushLead?token=${reltoken}`;
    const dataJson = JSON.stringify([
      {
        Name: "联系人",
        Value: name,
      },
      {
        Name: "名称",
        Value: company,
      },
      {
        Name: "手机",
        Value: phone,
      },
      {
        Name: "备注",
        Value: "职务：" + position + ",微信号：" + wx,
      },
      {
        Name: "客户来源",
        Value:
          type === "1"
            ? "c5c1c1d1848f16e7832f001517543a50"
            : type === "2"
            ? "c5c1c1d1848f16e7832f001517543a49"
            : type === "3"
            ? "c5c1c1d1848f16e7832f001517543a48"
            : "c5c1c1d1848f16e7832f001517543a47",
      },
    ]);

    if (!name) {
      Modal.alert("提示", "姓名未填写");
      return;
    }
    if (!phone) {
      Modal.alert("提示", "手机号未填写");
      return;
    } else if (!/^1(3|4|5|6|7|8|9)\d{9}$/.test(phone)) {
      Modal.alert("提示", "手机号格式不正确");
      return;
    }

    if (name && phone) {
      instance
        .post(URL, {
          jsonData: dataJson,
        })
        .then((res) => {
          if (res.data.Status === "1") {
            Modal.alert("提示", "申请成功");
          } else {
            Modal.alert("提示", res.data.Message);
          }
        });
    }
  }, [company, name, phone, position, wx]);

  return (
    <Container>
      <div className="container">
        <div className="outer">
          <div className={`ban banner${type}`}></div>
          {/* 表单 */}
          <div className="form">
            {/* 姓名 */}
            <div className="line name">
              <label className="label">
                <span style={{ color: "#DD011B" }}>*</span>
                姓名
              </label>
              <InputItem
                placeholder="请输入姓名"
                value={name}
                onChange={(val) => {
                  setName(val);
                }}
                className="input"
                style={{ textAlign: "left" }}
              />
            </div>
            {/* 电话 */}
            <div className="line phone">
              <label className="label">
                <span style={{ color: "#DD011B" }}>*</span>
                手机
              </label>
              <InputItem
                placeholder="请输入手机号"
                value={phone}
                onChange={(val) => {
                  setPhone(val);
                }}
                className="input"
                style={{ textAlign: "left" }}
              />
            </div>
            {/* 验证码 */}
            {/* <div className="yzm">
              <input placeholder="验证码" className="input" />
              <button className="yzm_btn">获取验证码</button>
            </div> */}
            {/* 公司 */}
            <div className="line company">
              <label className="label">公司</label>
              <InputItem
                placeholder="请输入公司名称"
                value={company}
                onChange={(val) => {
                  setCompany(val);
                }}
                className="input"
                style={{ textAlign: "left" }}
              />
            </div>
            {/* 职务 */}
            <div className="line position">
              <label className="label">职务</label>
              <InputItem
                placeholder="请输入职务"
                value={position}
                onChange={(val) => {
                  setPosition(val);
                }}
                className="input"
                style={{ textAlign: "left" }}
              />
            </div>
            {/* 微信号 */}
            <div className="line wx">
              <label className="label">微信号</label>
              <InputItem
                placeholder="请输入"
                value={wx}
                onChange={(val) => {
                  setWx(val);
                }}
                className="input"
                style={{ textAlign: "left" }}
              />
            </div>
          </div>
          {/* 联系我 */}
          <div className="service" onClick={() => setVisible(true)}>
            <img
              src="/image/services.png"
              className="service_img btn1"
              alt=""
            />
          </div>
        </div>
        {/*  提交 */}
        <div className="submit_btn">
          <Button className="sub" onClick={onSubmit}>
            即刻提交，免费试用
          </Button>
        </div>
      </div>
      <Modal visible={visible} transparent maskClosable={false}>
        <div
          style={{
            height: "100%",
            display: "flex",
            flex: 1,
            justifyContent: "center",
            alignItems: "center",
          }}>
          <div
            style={{
              margin: "0 auto",
              width: 250,
              height: 291,
              background: "#ffffff",
              borderRadius: 8,
            }}>
            <div onClick={() => setVisible(false)}>
              <img
                src="./image/close.png"
                style={{
                  width: 16,
                  height: 16,
                  position: "absolute",
                  right: 10,
                  top: 10,
                  cursor: "pointer",
                }}
                alt=""
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
                alignItems: "center",
              }}>
              <img
                src="./image/logo.png"
                alt=""
                style={{ width: 114, height: 29, margin: "19px auto 22px" }}
              />
              <img src="./image/ewm.png" style={{ width: 164, height: 165 }} />
              <div
                style={{
                  marginTop: 10,
                  fontSize: 16,
                  fontWeight: 400,
                  color: "rgba(0, 0, 0, 0.45)",
                }}>
                长按添加客服二维码
              </div>
            </div>
          </div>
        </div>
      </Modal>
    </Container>
  );
}

const Container = styled.div`
  .container {
    width: 100%;
    height: 100%;
    overflow-y: auto;
    display: flex;
    box-sizing: border-box;
  }

  .outer {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  .ban {
    width: 100%;
    height: 517px;
    background-image: url("/image/banner.png");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center;
  }
  .banner {
    background-image: url("/image/banner.png");
  }
  .banner1 {
    background-image: url("/image/banner1.jpg");
  }
  .banner2 {
    background-image: url("/image/banner2.jpg");
  }
  .banner3 {
    background-image: url("/image/banner3.jpg");
  }

  .form {
    margin-top: 24px;
    padding: 0 23px;
    display: flex;
    flex-direction: column;
  }

  .line {
    display: flex;
    flex-direction: column;
  }

  .label {
    font-size: 16px;
    font-weight: 400;
    color: rgba(0, 0, 0, 0.85);
    line-height: 22px;
  }

  .input {
    height: 46px;
    background: #ffffff;
    border-radius: 4px;
    border: 1px solid rgba(0, 0, 0, 0.11);
    font-size: 16px;
    padding-left: 14px;
    margin-top: 8px;
    box-sizing: border-box;
  }

  .phone {
    margin-top: 16px;
  }

  .yzm {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  .yzm_btn {
    width: 215px;
    height: 46px;
    background: rgba(39, 99, 251, 0.06);
    border-radius: 4px;
    border: none;
    font-size: 16px;
    font-weight: 400;
    color: #3a72ff;
    margin-top: 8px;
    line-height: 22px;
  }

  .company,
  .position,
  .wx {
    margin-top: 24px;
  }

  .wx {
    margin-bottom: 140px;
  }

  .submit_btn {
    position: fixed;
    left: 0;
    bottom: 0;
    width: 100%;
    height: 120px;
    background: #f7f7f7;
    text-align: center;
  }

  .sub {
    width: 330px;
    height: 48px;
    margin: 11px auto 0;
    background: #2763fb;
    border-radius: 4px;
    border: none;
    font-size: 16px;
    font-weight: 500;
    color: #ffffff;
    line-height: 48px;
  }

  .service {
    position: fixed;
    right: 12px;
    // top: 470px;
    bottom: 145px;
  }

  .service_img {
    width: 67px;
    height: 80px;
  }
`;
